const messages = {
  en: {
    translations: {
      headings: {
        dashboard: "Dashboard",
        forecast: {
          title: "Forecast",
          downloads: "Downloads",
          analysis: "Analysis",
        },
        automations: "Automations",
        settings: "Settings",
      },
      sideBar: {
        editAvatarHeading: "Edit your photo",
        addAvatar: "Add photo",
        deleteAvatar: "Delete photo",
      },
      languageSelector: "Language",
      company: "Company",
      login: {
        title: "Sign in to our platform",
        emailLabel: "Your email",
        email: 'email',
        emailPlaceholder: "example@company.com",
        passwordLabel: "Your password",
        passwordPlaceholder: "mypassword",
        signIn: "Sign In",
        error: "Invalid user and/or password!",
        logOut: "Log Out",
      },
      analyzeSizeCurve: "Analyze Size Curve",
      selectAction: "Select",
      sessionMessage: "Your session is about to expire. Do you want to continue?",
      continue: "Continue",
      channel: "Channel",
      suggestedActions: "Suggested Actions",
      category: "Category",
      orderGeneratedBy: "Order generated by",
      moreInformationSoon: "More information coming soon.",
      conflictingOperationMessage: "It is not possible to remove and update the same product at the same time.",
      region: "Region",
      supplier: "Supplier",
      noItemsForColumn: "There is no valid information for this product on this column",
      totalQtyToBeBought: "Total quantity to be purchased.",
      effectivePurchaseProductValue: "Effective product purchase value",
      unitOfMeasure_title: "(unit of measure)",
      final_title: "Final",
      suppliers: "Suppliers",
      store: "Store",
      missingSuppliersInfo: "Warning: Some products are missing supplier information.",
      settings: "Settings",
      creatingOrder: "Generating purchase order",
      removingItem: 'Removing item from order',
      updatingMessage: "Updating product data...",
      updateAndRemoveMessage: "Updating and removing products..",
      updatingItems: "item being updated",
      purchaseParam: "Purchase Parameters",
      purchaseQualityMenu: "Purchase Quality",
      updatingItems_plural: "items being updated",
      removingItem_item: "item being removed",
      openOrders: "Open Orders",
      removingItem_plural: "items being removed",
      ordersHystory: "Order History",
      minimumInventory_pt1: "Inventory",
      productMinimumQty: "Product minimum quantity",
      productMinimumInvetory: "Product minimum inventory",
      minimumInventory_pt2: "Minimum",
      cancelling: "Cancelling",
      cancellingOrder: "order undergoing cancellation…",
      openPurchaseOrders: "Open Purchase Orders",
      myAccount: "account",
      surplus: "Surplus",
      users: "Users",
      chooseFile: "Choose file",
      organization: "Organization",
      passRequirements: "Please enter the new password according to the requirements:",
      oneLetterUpperCase: "One uppercase letter (A–Z)",
      stores: "Stores",
      oneLetterLowerCase: "One lowercase letter (a–z)",
      specialCharacter: "One special character (!@#$)",
      atLeast6Characters: "At least 6 characters",
      oneNumber: "One number (0–9)",
      loadingStoresRec: "Loading purchase recommendations...",
      loadingStores: "Loading stores...",
      registeredOn: 'Registered on',
      loadingOrderItens: 'Loading order details...',
      logout: "Log out",
      usersManagement: "Users",
      lastRegisteredUsers: "Last registered users",
      profilePicture: "Profile picture",
      loadingOrdersByStores: "Loading store orders...",
      difSumMonths: "Difference relative to the sum of all months",
      planAdjustment: "Plan Adjustment",
      chosePicture: "Chose picture",
      permissions: "Permissions",
      user: "User",
      role: "Role",
      productHierarchy: "Product hierarchy",
      numberOfLevels: "Number of levels",
      level: "Level",
      levelName: "Level name",
      channelRegistration: "Channel registration",
      // FORECAST SECTION:
      year: "Year",
      month: "Month",
      weeks: "Weeks",
      months: "Months",
      filterBy: "Filter by",
      generatedOn: "Forecast generated on",
      generationDate: "Generation date",
      forecastDate: "Forecast date",
      commercialWeek: "Commercial week",
      commercialWeeks: "Commercial weeks",
      monthlyForecast: "Forecast months",
      dataProcessing: "Data processing in progress",
      showFilter: "Filters",
      recentPredictions: "Loading recent predictions",
      hideFilter: "Hide filters",
      removeFilters: "Remove filters",
      products: "Products",
      fileError: "The selected file is unavailable. Select different dates",
      summary: "Download summary",
      singleFile: "Single file (.xlsx)",
      singleFileCaption: "A sheet per week",
      multipleFiles: "Multiple files (.zip)",
      multipleFilesCaption: "A file per week",
      exportMultiple: "Export multiple",
      advancedExport: "Advanced export",
      forecasts: "Forecasts",
      selectCommWeek: "Forecasts generated in the following commercial weeks:",
      next: "Next",
      changeWeekModal: {
        body: "If you change the selected commercial weeks, the applied product filters will be reset.",
      },
      attention: "Warning!",
      options: "Options",
      downloadSummary: "Download summary",
      addAnotherMale: "Add another",
      addAnotherFemale: "Add another",
      addPeriod: "Add period",
      commercialCalendar: "Commercial Calendar",
      insertYear: "Insert a year between 1000 and 9999",
      sort: "Sort",
      graphicHeading: "Graphic Analysis",
      descriptiveHeading: "Descriptive Analysis",
      classicHeading: "Classic Analysis",
      productFilter: "Filter by product",
      griffe: "Griffe",
      grife: "Grife",
      line: "Line",
      group: "Group",
      totalSales: "Total sales",
      salesByColor: "Sales by color",
      salesBySizeGrid: "Sales by size grid",
      canceled: "Canceled",
      performance: "Performance",
      unitsSold: "Units Sold",
      industryProductMix: "Industry Product Mix",
      analysisBasedMessage: "Analysis based on product similarity",
      performanceFuture: "Future Performance",
      rovitexMatrix: "Rovitex Matrix",
      historicalAnalyses: "Historical Analyses",
      collectionOverview: "Collection overview",
      performanceByProduct: "Performance by product",
      avgPrice: "Average price",
      retail: "Retail",
      customerAdoption: "Customer Adoption",
      wholesale: "Wholesale",
      subgroup: "Subgroup",
      purchaseSuggestion: "Purchase Suggestion",
      purchaseSuggestion7: "Purchase Suggestion (7d)",
      purchaseSuggestion14: "Purchase Suggestion (14d)",
      purchaseSuggestion21: "Purchase Suggestion (21d)",
      averageSales: "Daily average purchase",
      collection: "Collection",
      segment: "Segment",
      regional: "Regional",
      salesRepresentative: "Sales Representative",
      recommendedPurchase: "Recommended Purchase",
      minimumInventory: "Minimum Inventory",
      actualPurchase: "Actual Purchase",
      leadTime: "Lead Time",
      linha: "Line",
      brand: "Brand",
      grupo: "Group",
      subgrupo: "Subgrupo",
      subgrupos: "Subgroups",
      graphType: "Graph style",
      lines: "Lines",
      columns: "Columns",
      showing: "Showing",
      product: "Product",
      estimated: "Estimated",
      realized: "Realized",
      percentDiff: "Diff %",
      diff: "Difference %",
      wape: "WAPE",
      selectOneOption: "Select one option",
      selectAtLeastOne: "Select at least one option",
      sortBy: "Sort by",
      highest: "Highest",
      lowest: "Lowest",
      // Página "Análise Descritiva"
      aidronView: "Aidron view",
      classicView: "Classic view",
      resultsSubtitle: "Demand forecast (in clothing pieces)",
      week: "Week",
      analyseGraph: "Analyse graph",
      all: "All",
      choseProducts: "Chose products",
      checkAll: "Select all",
      uncheckAll: "Deselect all",
      analyse: "Analyse",
      close: "Close",
      estActDif: "Est  |  Act  |  Diff%",
      centerMonth: "Center month",
      centerWeek: "Center week",
      expand: "Expand data",
      shrink: "Shrink data",
      selectedProducts: "Selected products",
      // Página "Visualização Clássica"
      hideColumns: "Hide columns",
      unhideColumns: "Unhide columns",
      filterByDate: "Filter by date",
      filterByName: "Filter by name",
      searchByProduct: "Search by product",
      searchLabel: "Search product...",
      finalizeOrder: "Finalize Order",
      orderDate: "Order date",
      searchError: "No results found for your search.",
      exportData: "Export data",
      reference: "Referência",
      purchaseOrderHistory: "Purchase Order History",
      cancelOrder: 'Cancel order',
      deleteOrder: 'Delete order',
      orderCancelled: 'Order cancelled',
      cancelOrderReturnToEdit: 'By cancelling, the products from this Purchase Order will return to the Order Editing screen.',
      exportImage: 'Export image',
      aidronForecast: "AidronForecast",
      changeCommWeek: "Change commercial week",
      editEstimated: "Edit estimations",
      finishRevision: "Finish revision",
      revision: "Revision",
      revised: "Revised",
      revenue: "Revenue",
      send: "Send",
      reviewAndSend: "Review and send",
      typeYear: "Type a year..",
      forecastPeriod: "Forecast period",
      showHistory: "Show history",
      analyseAndIntegratePredictions: "Analyse and integrate forecasts",
      analysePredictions: "Analyse predictions",
      saveRevision: "Save revision",
      closeRevision: "Close revision",
      cancel: "Cancel",
      dontSave: "Discard changes",
      forecastRevision: "Forecast revision",
      unsavedChangesModal: {
        heading: "Save changes?",
        body: "There are unsaved values in the forecast revision. Do you wish to save these changes?",
        promptBody: "There are unsaved values in the forecast revision. Are you sure you want to leave?",
      },
      dataSent: "Data was successfully sent!",
      sent: "Sent",
      submittedOn: "Submitted on",
      sendingPreviewModal: {
        heading: "Submit summary",
        alreadySentProducst: "You selected items that were already sent, so these were withdrawn from the list above.",
        body: "Review the data that will be sent. To edit, go back to the previous page.",
      },
      noSendingIntegrationModal: {
        heading: "There is no integration with your planning system!",
        body: "You have no integration with your planning system. We generated an export file with this version of the forecast.",
        downloadFile: "Download file",
      },
      back: "Back",
      formerWeekModal: {
        heading: "Confirm the commercial week",
        bodyEditing: "The forecast you are analysing was generated in the commercial week number ",
        bodySending: "The forecast you are about to send to your system was generated in the commercial week number ,",
        body2: " of ",
        body3: ", which is not the latest forecast issued.",
        question: "How do you wish to continue?",
        stay: "Stay in week ",
        goToCurrent: "Go to latest commercial week",
      },
      savedUnsent: "Saved and unsent",
      seeSendingStatus: "See sending status",
      sendingStatus: "Sending status",
      productsAmount: "No of products",
      seeDetails: "See details",
      hideDetails: "Hide details",
      noCheckedProductsModal: {
        heading: "There are no selected products!",
        body: "In order to continue, select one or more products from the table.",
      },
      productRegistration: "Product registration",
      remove: "Remove",
      hideProducts: "Hide products",
      showRegisteredProducts: "Show registered products",
      saveModifications: "Save changes",
      errorModal: {
        heading: "Oops! Something went wrong",
        checkFields: "Check the highlighted fields and try again.",
        changesNotSaved: "Changes were not saved. Please contact the system administrator.",
      },
      typeValidName: "Type a valid name",
      season: "Season",
      seasonRegistration: "Seasons registration",
      hideSeasons: "Hide seasons",
      showRegisteredSeasons: "Show registered seasons",
      and: "and",
      filterBySeason: "Filter by season",
      predictions: "Predictions",
      showSeasons: "Show seasons",
      bulkImport: "Bulk import",
      seasonsBulkImport: "Seasons bulk import",
      step: "Step",
      importModal: {
        step1Instruction: "Download the template and fill it according to the example inside it.",
        step2Instruction: "Upload the template containing the data to be registered.",
        step3Instruction: "Verify the data to be imported and confirm the import.",
        error:
          "There was an error on importing data. Verify the inputted data in the file and, if the problem persists, please contact the system administrator.",
      },
      choseFile: "Chose file",
      fileUploaded: "The file was uploaded!",
      confirm: "Confirm",
      seasonNumber: "Season number",
      seasonNumbers: "Season numbers",
      seasonName: "Season name",
      seasonNames: "Season names",
      seasonMonths: "Season months",
      importSeasons: "Import seasons",
      importProducts: "Import products",
      percentDifference: "Percent difference",
      productNumber: "Product number",
      example: "Example",
      optional: "Optional",
      consultOnSeasonsSheet: 'Consult number in the "Season Numbers" sheet',
      new: "New",
      seasons: "Seasons",
      wereSaved: "wereSaved",
      wereNotSaved: "were NOT saved",
      verifyData: "Check the inputted data and try again. If the problem persists, contact the system administrator.",
      // PÁGINA AÇÕES
      simulateActions: "Simulate actions",
      simulateActionsSubtitle: "Simulate various future scenarios in real-time",
      exploreScenarios: "Explore internal and external scenarios",
      actionsCheckout: "Actions Checkout",
      actionsCheckoutSubtitle: "Actions marked for adjustment",
      salesOpportunities: "Sales Opportunities",
      buyOptimization: "Purchase Optimization",
      storesOpportunities: "Store Opportunities",
      registerNewUser: "Register New User",
      comingSoon: "Coming soon",
      adjustmentPageTitle: "Product | Supply Adjustments",
      otbPageTitle: "Product | OTB Adjustments",
      opportunity: "Opportunity",
      adjustmentsRecommendations: "Adjustment Recommendations",
      retrievingData: "Retrieving data from your plan...",
      loadingSupplyDetails: "Loading supply details...",
      languagePortuguese: "Portuguese",
      langaugeEnglish: "English (US)",
      opportunities: "Opportunities",
      opportunitiesAnalysis: "Opportunities analysis",
      assortmentOpportunities: "Optimization Opportunity",
      inventoryDetails: "Inventory Details",
      loadingData: "Loading data...",
      riskSalesLostColumn: "Lost Sales Risk",
      capitalTiedUp: "Tied-up Capital",
      percentageOfShortage: "% of Shortage",
      inventoryQualityIndex: "Inventory Quality Index",
      quantityShort: "Quantity Short",
      quantityStoreDescription: "Available Stock in Store",
      inCheckout: "in checkout",
      quantityCDDescription: "Average Stock in Distribution Center",
      quantityCD: "Quantity in DC",
      priority: "Relevance ($)",
      quantityStore: "Quantity in Store",
      purchaseAdjustment: "Purchase Adjustments",
      quantityShortDescription: "Quantity Short in Stock to Meet Forecasted Demand",
      salesBreakdown: "Sales breakdown",
      salesBreakdown_A: "Sales breakdown A",
      error404HTTPMessage: "We couldn't find what you were looking for. Check if the address is correct or go back to the previous page.",
      error400HTTPMessage: "Some information is incorrect or incomplete. Review what was entered and try again",
      salesBreakdown_B: "Sales breakdown B",
      salesBreakdown_C: "Sales breakdown C",
      error409HTTPMessageHistoryPage: "This request cannot be changed because it has already been completed or canceled.",
      error409HTTPMessageSingular: "This product cannot be changed because it is already included in an order.",
      error409HTTPMessagePlural: "These products cannot be changed because they are already included in an order.",
      priceRange: "Price tier",
      checkInformation: "Check the informations provided",
      error500HTTPMessage: "We couldn't complete your request right now. Please wait a few seconds and try again. If the problem persists, contact support.",
      priceRange_high: "High tier",
      priceRange_medium: "Mid tier",
      priceRange_low: "Low tier",
      high: "Alta",
      pageNotFound: "Page not found",
      actionNotAllowed: "Action not allowed",
      medium: "Média",
      low: "Baixa",      
      higherLikehoodOfSale: "Higher likelihood of sale",
      belowForecast: "below the Forecast",
      futurePlan: "Future Plan",
      currentInventoryView: "Current Inventory View",
      channelReplenishment: "Channel Replenishment",
      storeDetails: "Store Details",
      familyProduct: "Product family",
      replenishment: "Replenishment",
      shortTerm: "Short Term",
      longTerm: "Long Term",
      riskSalesLost: "At Risk of Lost Sales",
      planAdjustmentOpp: "In Plan Adjustment Opportunities",
      stockOrSalesIncreaseOptimization: "Stock or sales increase optimization",
      noItemsForCurveBreak: "No items for this product in this curve break.",
      noItemsForPriceRange: "No items for this product in this price range.",
      totalOpportunities: "Total opportunities",
      costReduction: "cost reduction",
      channels: "Channels",
      adjustingPlanAndStock: "adjusting plan and stock",
      assortmentAdjustment: "Assortment adjustment",
      assortmentOptimization: "Otimização de Sortimento",
      enterSearchTerm: "Enter search term...",
      additionalSale: "Additional Sale",
      addingStockAndSales: "adding stock and sales",
      above: "above",
      below: "Below",
      productPlan: "Product plan",
      piecesOfClothingAbbreviation: "items",
      theForecast: "forecast",
      paretoAnalysis: "Pareto Analysis",
      ofTheTotal: "of the total",
      eightyPercentOfGap: "products account for 80% of the gap",
      channelsTarget: "Channels target",
      waitingForData: "Waiting for data",
      currentPlanVsForecast: "Current plan vs. Forecast",
      monthsSumDifference: "Difference compared to the sum of all months",
      productOpportunities: "Product Opportunities",
      productSalesAverage: "Product Sales Average",
      channelOpportunities: "Channel Opportunities",
      marketInsights: "Market Insights",
      analysis: "Analysis",
      productPlanVsForecast: "Product: Plan vs. Forecast",
      storesPlanVsForecast: "Stores: Plan vs. Forecast",
      channelsTargetVsForecast: "Channels: Target vs. Forecast",
      forecastAccuracy: "Forecast Accuracy",
      actions: "Actions",
      adjustProductPlan: "Adjust Product Plan",
      orderDateSent: "Order Date",
      avoidSalesLoss: "Avoid Sales Loss",
      lossByStore: "Loss By Store",
      lossByStoreRankingTitle: "Store Loss Ranking",
      lossByStoreRankingSubtitle: "Top 10 stores with the highest shortage value for the {{family}} family.",
      lossByStoreRankColumn: "#",
      lossByStoreStoreColumn: "Store",
      lossByStoreRiskColumn: "Loss Risk",
      lossByStoreEmptyRanking: "There is no loss by store data for this family.",
      storeLabel: "Store {{storeId}}",
      optimizePurchase: "Optimize Purchase",
      buyer: "Buyer",
      vendorList: "Vendor list",
      productSubgroups: "Product Subgroups",
      storeProducts: "Store products",
      unitsOfMeasure: "Units of Measure",
      daily: "Daily",
      sales: "Sales",
      stockUnits: 'Stock units',
      code: "Code",
      description: "Description",
      addPrefixOfMeasure: "Add measurement unit",
      addPrefixOfMeasureLabel: "Add Prefix of Measure",
      return: "Return",
      emptyResult: "Your search did not return any results.",
      exclude: "Delete",
      purchaseMeasurementUnitParameters: "Measurement unit parameters for purchasing",
      maxTenCharacters: "Maximum of 10 characters",
      max255Characters: "255 characters",
      prefixesUpdateSuccessMessage: 'Prefixes updated!',
      highestValue: "highest value",
      details: "Details",
      successTitle: "Update completed successfully!",
      acronym: "Acronym",
      successOnOrder: 'Order successfully placed',
      effectivePurchase: "Effective Purchase",
      supply: "Store Supply",
      conversionFactor: 'Conversion factor',
      conversionFactorDescription: "Conversion factor between the purchase unit and the unit sold by the supplier",
      modifyOrder: "Modify",
      successMessage: "The following products have been updated",
      confirmSupplier: "Confirm the supplier",
      submitOrder: "Create order",
      choseRegionAndStore: "Choose a region and store",
      lowestValue: "lowest value",
      showAllOpportunities: "Show All Opportunities",
      opportunityType: "Opportunity Type",
      orderBy: "Order by",
      done: "Done",
      additionalSaleExplanation:
        "This opportunity is mapped whenever your future sales plan is below the center of customer demand (customer demand for this product can be observed in green on the chart).",
      expectedIncreaseInSales: "Expected Increase in Sales",
      avoidSalesLossExplanation:
        "This opportunity is identified whenever sales from recent months are below or close to the minimum threshold of customer demand.",
      optimizePurchaseExplanation:
        "This opportunity is mapped whenever your future sales plan is above the maximum threshold of demand for this product. On the chart, this demand threshold can be observed in green.",
      futurePurchaseReduction: "Future Purchase Reduction",
      active: "Active",
      reactivated: "Reactivated",
      checkout: "Checkout",
      percent: "Percentage",
      opportunitySize: "Opportunity Size",
      status: "Status",
      deletion: "Deletion",
      reopen: "Reopen",
      wishReopenOpportunity: "Do you wish to reopen the opportunity?",
      opportunityWillBeAnalysed: "The opportunity will be analyzed",
      opportunityWillCheckout: 'By selecting this option, the opportunity will receive the "Checkout" status.',
      opportunityHasGoneCheckout: "The opportunity has been sent to Action Checkout!",
      notAnOpportunity: "Not an opportunity",
      describeDeletionReason:
        "By selecting this option, you can describe the reason for deletion, and the opportunity will be removed from the opportunity list.",
      opportunityHasBeenRemoved: "The opportunity has been removed.",
      removeFromCheckout: "Remove from Checkout",
      opportunityWillRemainInList:
        'By selecting this option, the opportunity will remain in the opportunity list with the "Active" status.',
      opportunityHasLeftCheckout: "The opportunity has been removed from the Checkout list.",
      finalizeOpportunityOption: "Finalize the Opportunity",
      finalizeOpportunityOptionText: "By selecting this option, you can describe the actions you took to indicate that you acted on this Opportunity and that it can now be finalized.",
      opportunityHasBeenFinished: "The opportunity has been successfully finalized!",
      describeExecutedActions: "Briefly describe the Actions executed",
      errorContactAdmin: "An error occurred. Please try again or contact the system administrator.",
      finish: "Finish",
      describeReason: "Briefly describe the reason",
      remainingCharacters: "Remaining Characters",
      transforInAction: "Transform into Action",
      removeOpportunity: "Discard Opportunity",
      save: "Save",
      productHasOtherOpportunity: "This product has another opportunity",
      productHasOtherOpportunities: "This product has other opportunities",
      analyseOpportunity: "Analyze Opportunity",
      analyseOpportunities: "Analyze Opportunities",
      actionRecommendation: "Action Recommendation",
      advancedAnalysis: "Advanced Analysis",
      currentPlan: "Current Plan",
      opportunityChartError:
        "An error occurred while loading the chart for this opportunity. Please contact the system administrator.",
      willBeListedAsOpportunity: "It will be listed again as an Opportunity, and its value will be included in the active total.",
      removedOpportunities: "Removed Opportunities",
      opportunityWasReopened: "The opportunity has been reopened.",
      noRemovedOpportunities: "There are no removed opportunities.",
      period: "Period",
      opportunityTypeTitle: "{{opportunityTitle}} Opportunity",
      help: "Help",
      planVsForecastSubtitle:
        "Analysis of the main discrepancies between the company's official plan and the Forecast generated by Aidron",
      planVsForecastAnalysis: "Current Plan vs Forecast Analysis",
      mainGrouping: "Main Grouping",
      salesImpact: "Sales Impact",
      factorsThatImpactSales: "Factors That Impact Sales",
      groupingTitle: "{{groupingName}} grouping",
      planVsForecast: "Plan vs Forecast",
      monthlyBreakdown: "Monthly Breakdown",
      aiForecast: "AI Forecast",
      greatPerformance: "Great Performance",
      ofAboveThanDemandProducts: "of products with sales above demand",
      criticalPoints: "Criticals",
      ofBelowThanDemandProducts: "of products with sales below demand",
      productDriversListingAndPercent: "Below is the list of factors impacting sales and the percentage impact of each",
      upcomingFeature: "This feature will be available soon.",
      mainGroupingBreakdown: "Main Grouping Breakdown",
      total: "Total",
      analyzeProducts: "Analyze Products",
      accuracyAnalysis: "Accuracy Analysis",
      activeOpportunities: "Active Opportunities",
      possibleUpcomingFeature: "This feature may soon be available for your company.",
      productDrivers: "Factors Impacting This Product's Sales",
      productDriversExplanation:
        "This analysis identifies the % impact of each factor on this product's sales. It is essential for diagnostics and proposing actions to optimize stock and/or increase sales.",
      realizedDeviationVsDemand: "Executed Deviation vs Demand",
      realizedDeviationVsDemandDescription:
        "Average percentage of deviations between actual results and customer demand over the last two months. The higher this indicator, the less predictable the item, potentially indicating operational issues that need resolution to make the plan more accurate.",
      lastMonthSaleVariation: "Last Month's Sales Variation",
      lastMonthSaleVariationDescription:
        "Percentage variation between sales in the second-to-last and last months. When a variation spike occurs (and it's not due to a special date between the months), this may indicate an unforeseen sudden change.",
      saleAnomalyProbability: "Sale Anomaly Probability",
      saleAnomalyProbabilityDescription:
        "This value indicates the probability that the AI identified an operational issue in historical sales. A high index suggests the last month's sales variation is not just due to customer demand but might reflect operational actions (e.g., price changes, assortment strategy, etc.).",
      aiAccuracyOverClient: "AI Accuracy vs Plan",
      aiAccuracyOverClientDescription:
        "A positive number means the AI outperformed the Plan over the last six months. Zero indicates no difference for the total period. A negative value means the AI underperformed the Plan. However, if accuracy is low and the anomaly probability is high, operational factors outside the AI's variables may need to be addressed to improve the models.",
      indexesToSupport: "Indexes to Support the Analysis",
      productView: "Product View",
      forecastGeneratedIn: "Forecast generated on",
      address: "Address",
      indicator: "Indicator",
      searchByHierarchy: "Search by hierarchy",
      type: "Type",
      filterByHierarchy: "Filter by hierarchy",
      clearFilters: "Clear filters",
      analyzeProduct: "Analyze products",
      salesHistory: "Sales history",
      freezeColumns: "Freeze columns",
      choseColumns: "Chose columns",
      "Precipitação (Quantidade de chuvas)": "Precipitation (Rainfall)",
      "Índice Geral de Preços (IGPM)": "General Price Index (IGPM)",
      "Índice de confecção de artigos do vestuário e acessórios": "Garment and Accessories Manufacturing Index",
      "Índice de importação de itens de vestuário": "Clothing Items Import Index",
      Preço: "Price",
      Margem: "Margin",
      "Índice de vendas reais no varejo": "Real Retail Sales Index",
      "Índice de vendas reais no varejo do vestuário": "Clothing Retail Real Sales Index",
      Temperatura: "Temperature",
      "Brasileiros comprando itens de vestuário fora do Brasil": "Brazilians Buying Clothing Items Abroad",
      Chuva: "Rain",
      "Produção de artigos do vestuário e acessórios no Brasil": "Garment and Accessories Production in Brazil",
      "Venda do Varejo de vestuário Brasil": "Clothing Retail Sales in Brazil",
      "Venda do Varejo no Brasil": "Retail Sales in Brazil",
      "Fluxo de Clientes (Índices do Varejo no Brasil)": "Customer Flow (Retail Indices in Brazil)",
      percentParticipation: "Participation %",
      ai: "AI",
      differenceAidronAndClient: "Diff AI x Current Plan",
      percentAidronVsClient: "Diff% AI x Current Plan",
      partPercent: "Part %",
      maxPot: "Max Pot",
      minPot: "Min Pot",
      maxPotential: "Maximum Potential",
      minPotential: "Minimum Potential",
      projection: "Projection",
      realizedSales: "Realized Sales",
      upperLimitAbbreviation: "Up. Limit",
      upperLimit: "Upper Limit",
      lowerLimitAbbreviation: "Low. Limit",
      lowerLimit: "Lower Limit",
      percentDiffAIVsProjection: "Diff% AI x Projection",
      percentDiffCurrentPlanVsProjection: "Diff% Current Plan x Projection",
      percentParticipationOnRealized: "% Participation in Realized",
      percentDifferenceAIVsRealized: "Diff% AI x Realized",
      percentDifferenceCurrentPlanVsRealized: "Diff% Current Plan x Realized",
      percentParticipationInRealized: "% Participation in Realized",
      percentDifferenceAIVsStorePlan: "Diff% AI x Store Plan",
      aiAdjustment: "AI Adjustment",
      newPlan: "New Plan",
      lastForecastGeneratedOn: "Last forecast generated on",
      analyzeProductAccuracy: "Analyze Product Accuracy",
      customerDemand: "Customer Demand",
      stockOptimization: "Stock Optimization",
      opportunitiesCheckout: "Opportunities Checkout",
      checkoutSummary: "Checkout Summary",
      noOpportunitiesGoTo: "No opportunities were sent to Checkout. To do so, go to the",
      opportunitiesPage: "Opportunities page",
      opportunityWasFinalized: "Opportunity was finalized",
      currentSupplierSelected: "Current supplier selected. You may change it if needed.",
      storeSalesIncrease: "Store Sales Increase",
      proceed: "Proceed",
      youMustSelectASupplier: 'Please select a supplier to continue with your order.',
      storePurchaseOrders: "Store Purchase Orders",
      opportunityWillBeFinalized:
        "By clicking Ok, this opportunity will be finalized and marked as Applied in the company's current Planning",
      newPhotoSaved: "Your new photo has been successfully saved.",
      newPasswordSaved: "New password successfully saved!",
      newPasswordNotSaved:
        "Your password could NOT be saved. Please try again in a moment. If the problem persists, contact the system administrator.",
      changePassword: "Change password",
      newPassword: "New password",
      repeatNewPassword: "Repeat new password",
      savePassword: "Save password",
      newPlanUnsavedChanges: "There may be unsaved changes in the New Plan edit. Are you sure you want to leave?",
      adjustSalesPlan: "Adjust Sales Plan",
      backToOriginalValue: "Return to Original Value",
      clientDemandVsPlan: "Client Demand vs. Plan",
      salesProblemProbability: "Sales Problem Probability",
      differenceAIAccuracyVsPlan: "Difference in AI Accuracy vs. Plan",
      featureComingSoon: "This feature will be available soon.",
      differenceFromPlan: "Difference from Plan",
      avoidedStockSurplus: "Avoided Stock Surplus",
      increaseInSales: "Increase in Sales",
      newPlanAnalysis: "New Plan Analysis",
      saving: "Saving",
      aiAdjustmentsFilter: "Filter AI Adjustments",
      removeFilter: "Remove Filter",
      filter: "Filter",
      current: "Current",
      difference: "Difference",
      cancelEdit: "Cancel edit",
      keepEditing: "Keep editing",
      editWarning: "There are unsaved changes on the screen. Do you want to save them?",
      of: "of",
      edit: "Edit",
      integrate: "Integrate",
      userActivity: "User Activity",
      projectedSalesProduct: "Projected product sales",
      opportunityAddedToCheckout: "Opportunity added to Actions Checkout!",
      opportunitySuccessfullyRemoved: "Opportunity successfully removed!",
      suggested: "Suggested",
      unitTitle: "(Unit)",
      productUnitOfMeasure: 'Product unit of measure',
      productPurchaseUnit: 'Product purchase unit',
      productPurchaseRecommendation: 'Product purchase recommendation',
      projectedSalesNext7Days: "Projected sales for the next 7 days.",
      projectedSalesNext14Days: "Projected sales for the next 14 days.",
      projectedSalesNext21Days: "Projected sales for the next 21 days.",
      suggestedPurchaseQty: "Suggested product purchase quantity",
      flowDependencyForSelling: "Flow Dependency for Selling",
      purchase: "Purchase",
      flowDependencyForSellingExplanation:
        "If the percentual is very high, the factors listed above will have little effect unless the customer flow increases in locations where this product has high sales. For products with Flow Dependency above 60%, we recommend operational actions to bring more visibility to the product.",
      opportunityAction: "Opportunity Action",
      consolidatedView: "Consolidated View",
      finalizeAction: "Finalize Action",
      finalizeOpportunity: "Finalize Opportunity?",
      // PÁGINA: ANÁLISE DE LOJAS
      storesAnalytics: "Stores Analytics",
      // PÁGINA: OPORTUNIDADES
      showingFilteredOpportunity: "Showing opportunities filtered by specific product",
      clearFilter: "Clear filter",
      noOpportunitiesFound: "No opportunities found with the applied filters",
      origin: "Origin",
      stockGroup: "Stock Group",
      productType: "Product Type",
      leadTime_pt1: "Lead",
      leadTime_pt2: "Time",
      productLeadTimeStore: "Product lead time to the store",
      productLeadTime: "Product lead time",
      daysTitle: "(days)",
      commercialGroup: "Commercial Group",
      family: "Family",
      productCode: "Product Code",
      loadingProductDetails: "Loading product details...",
    },
  },
};

export { messages };
